import axios from 'src/admin-axios';
import Constants from 'src/constants';

export const organizations = {
    namespaced: true,
    state: {
        organizationList: [],
        organizationDetails: {},
        OrganizationModuleDetails: {},
        organizationPurchaseList: [],
    },
    getters: {
        getOrganizationList (state) {
            return state.organizationList;
        },
        getOrganizationDetails (state) {
            return state.organizationDetails;
        },
        getOrganizationModuleDetails (state) {
            return state.OrganizationModuleDetails;
        },
        getOrganizationPurchaseList (state) {
            return state.organizationPurchaseList;
        },
    },
    mutations: {
        setOrganizationList (state, data) {
            state.organizationList = data;
        },
        setOrganizationDetails (state, data) {
            state.organizationDetails = data;
        },
        setOrganizationModuleDetails (state, data) {
            state.OrganizationModuleDetails = data;
        },
        setOrganizationPurchaseList (state, data) {
            state.organizationPurchaseList = data;
        },
    },
    actions: {
        async fetchOrganizationList ({ dispatch, commit }) {
            const url = '/organizations';
            try {
                const details = await axios.get(url);
                commit('setOrganizationList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting organization list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async createOrganization ({ dispatch }, payload) {
            const url = '/organizations';
            try {
                 await axios.post(url, payload);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating your organization.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async fetchOrganizationDetails ({ dispatch, commit }, payload) {
            const url = `/organizations/${payload.organizationId}`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your organization details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchOrganizationModuleDetails ({ dispatch, commit }, payload) {
            const url = `/organizations/${payload.organizationlId}/modules`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationModuleDetails', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting your organization module list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async  updateOrganizationModuleSettings ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}/modules/${payload.moduleId}`;
            try {
                await axios.put(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating organization module settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  createOrganizationModule ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}/modules`;
            try {
                await axios.post(url, payload.settings);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in creating organization module settings.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async  updateOrganization ({ dispatch }, payload) {
            const url = `organizations/${payload.organizationId}`;
            try {
                await axios.put(url, payload.editOrganizationDetails);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in updating organization details.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async fetchOrganizationPurchaseList ({ dispatch, commit }, payload) {
            const url = `organizations/${payload.organizationId}/time-slots`;
            try {
                const details = await axios.get(url);
                commit('setOrganizationPurchaseList', details.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in getting the selected organization purchase list.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
            }
        },
        async cancelOrgSlotSubscription ({ dispatch }, payload) {
            const url = `organizations/time-slots/${payload.orgTimeSlotId}/cancel`;
            try {
                await axios.post(url, payload.comment);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: 'Something went wrong in cancelling the slot subscription.',
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
    },
};
